import React, { useMemo, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppWrapper = () => {
  // Funzione per recuperare il tema dal localStorage o usare 'light' come predefinito
  const getInitialMode = () => {
    const savedMode = localStorage.getItem('themeMode');
    // Controlla se il valore salvato è valido ('light' o 'dark')
    if (savedMode === 'dark' || savedMode === 'light') {
      return savedMode;
    }
    // Altrimenti, ritorna il valore predefinito
    return 'light';
  };

  const [mode, setMode] = useState<'light' | 'dark'>(getInitialMode);

  // Usa useEffect per salvare il tema nel localStorage ogni volta che 'mode' cambia
  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: { mode },
        components: {
          MuiChip: {
            styleOverrides: {
              outlined: {
                backgroundColor: mode === 'dark' ? '#2d4a4a' : '#fff',
                border: '1px solid #098988',
                color: mode === 'dark' ? '#fff' : '#2d4a4a',
              },
            },
          },
        },
      }),
    [mode]
  );

  const toggleDarkMode = () =>
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

  return (
    <ThemeProvider theme={theme}>
      <App darkMode={mode === 'dark'} toggleDarkMode={toggleDarkMode} />
    </ThemeProvider>
  );
};

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

reportWebVitals();